module.exports = __webpack_public_path__ + "img/fly.c40cd499.svg";